import React from 'react';
import { ApiDataAccess } from '../../../infrastructure/ApiDataAccess';
import { ImageTitle } from '../../../core/ImageTitle';
import { ToolbarButton, ToolbarControl } from '../../../controls/ToolbarControl';
import { Card, Column, Row } from '../../../components/Containers';
import { DielineImage } from '../../../components/DielineImage';
import { StandardProduct } from './StandardProduct';
import { StandardProductAssignCategoryPopup } from './Popup/StandardProductAssignCategoryPopup';
import { StandardProductAssignSalesChannelPopup } from './Popup/StandardProductAssignSalesChannelPopup';
import { StandardProductAssignNamePopup } from './Popup/StandardProductAssignNamePopup';

export class StandardProductDetailsComponent extends React.Component {

    constructor(props) {
        super(props);

        if (!this.props.dataId) {
            throw new Error("DataId Property is required");
        }

        this.dataAccess = new ApiDataAccess('/data');
        this.standardProduct = new StandardProduct(this.props.dataId);

        this.state = {
            standardProduct: null,
            isValid: false,
            isPublished: false
        }

        this.deleteItem = this.deleteItem.bind(this);
        this.onPublishClick = this.onPublishClick.bind(this);
    }

    componentDidMount() {
        this.refresh();
    }

    refresh() {
        this.dataAccess.get(`/standard-product/${encodeURIComponent(this.props.dataId)}`)
            .then(data => {
                this.setState({
                    standardProduct: data,
                    isValid: data.isValid,
                    isPublished: data.isPublished
                });
            })
            .catch(error => {
                window.Router.setNotFound();
            });
    }

    deleteItem() {
        var self = this;
        window.Confirmation.show('Delete', 'Are you sure to delete this item?',
            function () {
                self.dataAccess.delete(`/standard-product/${encodeURIComponent(self.props.dataId)}`)
                    .then(data => {
                        window.Alerts.showSuccess('Standard Product ' + data.name + ' has been deleted');
                        window.Router.setRoute('/standard-products/all');
                    })
                    .catch(error => {
                        window.Alerts.showError('Standard Product cannot be deleted!');
                    });;
            }
        );
    }

    configurePricing() {
        var self = this;
        window.Router.setRoute(`/standard-products/${encodeURIComponent(self.props.dataId)}/pricing`);
    }

    onPublishClick() {
        var self = this;
        var isPublished = this.state.isPublished;

        this.standardProduct.publish(!isPublished)
            .then(data => {
                self.refresh();
                window.Alerts.showSuccess('Standard Product ' + data.name + ' has been ' + (isPublished ? 'unpublished' : 'published'));
            })
            .catch(ex => {
                if (ex.exceptions && ex.exceptions.length > 0) {
                    window.Alerts.showInfo(ex.exceptions[0].message);
                }
                if (ex.messages && ex.messages.length > 0) {
                    window.Alerts.showInfo(ex.messages[0]);
                }
            });
    }

    onCategoriesClick() {
        window.Modal.show(popup => {
            return (
                <StandardProductAssignCategoryPopup popup={popup} dataId={this.props.dataId} />
            )
        }, 'Industry Categories')
    }

    onSalesChannelsClick() {
        window.Modal.show(popup => {
            return (
                <StandardProductAssignSalesChannelPopup popup={popup} dataId={this.props.dataId} />
            )
        }, 'Sales Channels')
    }

    onNamesClick() {
        window.Modal.show(popup => {
            return (
                <StandardProductAssignNamePopup popup={popup} dataId={this.props.dataId} />
            )
        }, 'Names')
    }


    render() {
        return (
            <div className='product product-view-component'>
                {
                    this.state.standardProduct &&
                    <div>
                        <ImageTitle text={this.state.standardProduct.name} />

                        <ToolbarControl renderButtons={() => {
                            return (
                                <div>
                                    <ToolbarButton icon='glyphicon-th-list' text='List' onClick={() => window.Router.setRoute('/standard-products/all')} />
                                    <ToolbarButton icon='glyphicon-plus' text='New' onClick={() => window.Router.setRoute('/standard-products/new')} />
                                    {
                                        !this.state.standardProduct.isImmutable &&
                                        <>
                                            <ToolbarButton icon='glyphicon-pencil' text='Edit' onClick={() => window.Router.setRoute('/standard-products/' + encodeURIComponent(this.props.dataId) + '/edit')} />
                                            <ToolbarButton icon='glyphicon-trash' className='btn-danger' text='Delete' onClick={() => this.deleteItem()} />
                                        </>
                                    }
                                    <ToolbarButton icon='glyphicon-pencil' text='Copy' onClick={() => window.Router.setRoute('/standard-products/' + encodeURIComponent(this.props.dataId) + '/copy')} />
                                    <ToolbarButton icon={this.state.isPublished ? 'glyphicon-stop' : 'glyphicon-play'} text={this.state.isPublished ? 'unpublish' : 'publish'} onClick={this.onPublishClick} />
                                    <ToolbarButton icon='glyphicon-dollar' className='btn-danger' text='Price' onClick={() => this.configurePricing()} />
                                    <ToolbarButton icon='glyphicon-grain' className='btn-danger' text='Categories' onClick={() => this.onCategoriesClick()} />
                                    <ToolbarButton icon='glyphicon-usd' className='btn-danger' text='Channels' onClick={() => this.onSalesChannelsClick()} />
                                  {/*  <ToolbarButton icon='glyphicon-list-alt' className='btn-danger' text='Names' onClick={() => this.onNamesClick()} />*/}
                                </div>
                            )
                        }} />
                        <Card title='Packaging Type' subtitle='Packaging Type Details Below'>
                            <Row>
                                <Column>
                                    <label htmlFor='Pouch Type'>Pouch Type</label>
                                    {this.state.standardProduct.convertingMethod.name}
                                </Column>
                            </Row>
                            <Row>
                                <Column>
                                    <label htmlFor='Width'>Width</label>
                                    {parseFloat(this.state.standardProduct.width).toFixed(3)}
                                </Column>
                            </Row>
                            <Row>
                                <Column>
                                    <label htmlFor='Length'>Length</label>
                                    {parseFloat(this.state.standardProduct.length).toFixed(3)}
                                </Column>
                            </Row>
                            {
                                this.state.standardProduct.gusset &&
                                <Row>
                                    <Column>
                                        <label htmlFor='Gusset'>Gusset</label>
                                        {parseFloat(this.state.standardProduct.gusset).toFixed(3)}
                                    </Column>
                                </Row>
                            }
                            <Row>
                                <Column>
                                    <label htmlFor='Bottom Fill'>Bottom Fill</label>
                                    {this.state.standardProduct.bottomFill.name}
                                </Column>
                            </Row>
                            <Row>
                                <Column>
                                    <label htmlFor='Eyemark Placement'>Eyemark Placement</label>
                                    {this.state.standardProduct.eyemark.name}
                                </Column>
                            </Row>
                        </Card>

                        <Card title='Packaging Material' subtitle='Packaging Material Details Below'>
                            <Row>
                                <Column>
                                    <label htmlFor='Structure Specification'>Structure Specification</label>
                                    <strong>SPEC - {this.state.standardProduct.structureSpecId}</strong>
                                    <p>{this.state.standardProduct.structureSpec.name}</p>
                                </Column>
                            </Row>
                        </Card>

                        <Card title='Packaging Features' subtitle='Packaging Features Details Below'>
                            <div className="standard-product-packaging-features">
                                <div className="selections">
                                    <Row>
                                        <Column>
                                            <label htmlFor='Zipper'>Zipper</label>
                                            {this.state.standardProduct.zipper.name}
                                        </Column>
                                        <Column>
                                            <label htmlFor='Offset'>Offset</label>
                                            {this.state.standardProduct.zipperOffset}
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column>
                                            <label htmlFor='Hang Hole'>Hang Hole</label>
                                            {this.state.standardProduct.hangHole.name}

                                        </Column>
                                        <Column>
                                            <label htmlFor='Offset'>Offset</label>
                                            {this.state.standardProduct.hangHoleOffset}

                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column>
                                            <label htmlFor='Tear Notch'>Tear Notch</label>
                                            {this.state.standardProduct.tearNotch.name}

                                        </Column>
                                        <Column>
                                            <label htmlFor='Offset'>Offset</label>
                                            {this.state.standardProduct.tearNotchOffset}

                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column>
                                            <label htmlFor='Valve'>Valve</label>
                                            {this.state.standardProduct.valve.name}

                                        </Column>
                                        <Column>
                                            <label htmlFor='Offset'>Offset</label>
                                            {this.state.standardProduct.valveOffset}

                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column>
                                            <label htmlFor='Rounded Corners'>Rounded Corners</label>
                                            {this.state.standardProduct.roundedCorners.name}
                                        </Column>
                                        <Column />
                                    </Row>
                                    <Row>
                                        <Column>
                                            <label htmlFor='Double Cut'>Double Cut</label>
                                            {this.state.standardProduct.doubleCut.name}
                                        </Column>
                                        <Column />
                                    </Row>
                                    <Row>
                                        <Column>
                                            <label htmlFor='Gusset Type'>Gusset Type</label>
                                            {this.state.standardProduct.gussetType.name}
                                        </Column>
                                        <Column />
                                    </Row>
                                    <Row>
                                        <Column>
                                            <label htmlFor='Seal Width'>Seal Width</label>
                                            {this.state.standardProduct.sealWidth.name}
                                        </Column>
                                        <Column />
                                    </Row>
                                </div>
                                <div className="dieline">
                                    <label htmlFor='Dieline'>Dieline</label>
                                    <DielineImage
                                        id={1}
                                        zoom={1.5}
                                        lengthUomId={13}
                                        convertingMethodId={this.state.standardProduct.convertingMethodId}
                                        length={this.state.standardProduct.length}
                                        width={this.state.standardProduct.width}
                                        gusset={this.state.standardProduct.gusset}
                                        gussetTypeId={this.state.standardProduct.gussetTypeId}
                                        tearNotchId={this.state.standardProduct.tearNotchId}
                                        tearLineOffset={this.state.standardProduct.tearNotchOffset}
                                        hangholeId={this.state.standardProduct.hangholeId}
                                        hangholeOffset={this.state.standardProduct.hangholeOffset}
                                        zipperId={this.state.standardProduct.zipperId}
                                        zipperOffset={this.state.standardProduct.zipperOffset}
                                        eyemarkId={this.state.standardProduct.eyemarkId}
                                        bottomFillId={this.state.standardProduct.bottomFillId}
                                        valveId={this.state.standardProduct.valveId}
                                        valveOffset={this.state.standardProduct.valveOffset}
                                        sideSealWidthId={this.state.standardProduct.sealWidthId}
                                        roundedCornerId={this.state.standardProduct.roundedCornerId}
                                        doubleCutId={this.state.standardProduct.doubleCutId}
                                    />
                                </div>
                            </div>
                        </Card>
                    </div>
                }
            </div>
        );
    }
}